import { createApp } from 'vue';
import { eventBus } from '@tools/event-bus';
import EndDealModalComponent from './organization/adaf/modal-end-deal-component.vue';

/**
 * Init Deal Modal Component
 *
 * Wrapper of the 'End Modal Component'.
 * Handles opening modal and setting data from EventBus.
 */
export const adafDealActionsEnd = () => {
  const elementId = '#adaf-deal-end-modals';
  if (!document.querySelector(elementId)) {
    return null;
  }

  const component = {
    components: {
      'modal-deal-end': EndDealModalComponent,
    },
    data() {
      return {
        loading: false,
        isDealEndModalOpened: false,
        isDealExtendModalOpened: false,
        dealId: null,
        endDate: null,
        accountManagerEmail: '',
        dealBuyerFullname: '',
      };
    },
    mounted() {
      eventBus.addEventListener('deal-end-modal', (args) => {
        this.endDeal(args.detail);
      });
    },
    methods: {
      /**
       * Clear data
       */
      clear() {
        this.dealId = null;
      },
      /**
       * This method displays the end deal modal.
       */
      showDealEndModal() {
        this.isDealEndModalOpened = true;
      },
      /**
       * This method closes the end deal modal.
       */
      closeDealEndModal() {
        this.isDealEndModalOpened = false;
        this.clear();
      },
      /**
       * This method call action to end deal.
       *
       * @param event
       */
      endDeal(event) {
        const { dealId, endDate, accountManagerEmail, dealBuyerFullname } = event;
        this.dealId = dealId;
        this.endDate = endDate ? new Date(endDate.iso) : null;
        this.accountManagerEmail = accountManagerEmail;
        this.dealBuyerFullname = dealBuyerFullname;

        this.showDealEndModal();
      },
    },
  };

  return createApp(component).mount(elementId);
};
